module.exports = __webpack_public_path__ + "images/saab_small1473d075b846bd6c7b3f0e0b9d8282bf.png";